/**
 * Keeps IntelliGems price tests in sync when the theme updates prices via custom JS.
 * Module row prices stay hidden until the customer picks a size; only one IG price shows.
 */
(function () {
  'use strict';

  var IG_POLL_MS = 100;
  var IG_POLL_MAX_MS = 15000;
  var refreshTimer = null;
  var HIDDEN_CLASS = 'is-price-hidden';
  var SIZE_SELECTED_ATTR = 'data-ig-size-selected';

  function parseIgMoneyToCents(value) {
    if (value == null || value === '') return null;
    var dollars = parseFloat(String(value).replace(/[^0-9.]/g, ''));
    return Number.isFinite(dollars) ? Math.round(dollars * 100) : null;
  }

  function igPriceCents(variantId, fallbackCents) {
    var ig = window.igData && window.igData.price && window.igData.price.getPriceByVariantId;
    if (!ig) return fallbackCents;
    var cents = parseIgMoneyToCents(ig.call(window.igData.price, String(variantId)));
    return cents == null ? fallbackCents : cents;
  }

  function igCompareCents(variantId, fallbackCents) {
    var ig = window.igData && window.igData.price && window.igData.price.getComparePriceByVariantId;
    if (!ig) return fallbackCents;
    var cents = parseIgMoneyToCents(ig.call(window.igData.price, String(variantId)));
    return cents == null ? fallbackCents : cents;
  }

  function formatMoneyFromCents(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    var amount = cents / 100;
    var currency = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) || 'USD';
    var locale = (typeof Shopify !== 'undefined' && Shopify.locale) || 'en';
    return amount.toLocaleString(locale, { style: 'currency', currency: currency });
  }

  function getVariants(form) {
    var el = form && form.querySelector('.js-ms-variants-json');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function findModuleVariant(selection, variants) {
    return (
      variants.find(function (v) {
        return (
          v.options &&
          v.options.includes(selection.colorOption) &&
          v.moduleName &&
          v.moduleName.includes(selection.moduleName) &&
          v.size &&
          v.size.includes(selection.sizeOption)
        );
      }) || null
    );
  }

  function isOptionsPanelOpen(module) {
    var panel = module.querySelector('.js-ms-options');
    return panel && !panel.classList.contains('hide');
  }

  function isModuleConfirmed(module) {
    var footer = module.querySelector('.js-ms-footer');
    return footer && !footer.classList.contains('hide');
  }

  function hasUserSelectedSize(module) {
    return module.getAttribute(SIZE_SELECTED_ATTR) === 'true';
  }

  function markSizeSelected(module) {
    module.setAttribute(SIZE_SELECTED_ATTR, 'true');
  }

  function clearSizeSelected(module) {
    module.removeAttribute(SIZE_SELECTED_ATTR);
  }

  function shouldShowModulePrice(module) {
    if (isModuleConfirmed(module)) return true;
    if (isOptionsPanelOpen(module)) return hasUserSelectedSize(module);
    return true;
  }

  function setModulePriceVisible(module, visible) {
    var container = module.querySelector('.product__mso--price');
    if (!container) return;
    container.classList.toggle(HIDDEN_CLASS, !visible);
  }

  function getModuleSelection(module, mainColorValue) {
    var moduleNameEl = module.querySelector('.js-ps-ms-name');
    var colorInput = module.querySelector('.js-ps-mso-color:checked');
    var sizeInput = module.querySelector('.js-ps-mso-size:checked');
    if (!moduleNameEl || !sizeInput) return null;

    var colorOption = mainColorValue || (colorInput && colorInput.value);
    if (!colorOption) return null;

    return {
      colorOption: colorOption,
      sizeOption: sizeInput.value,
      moduleName: moduleNameEl.value,
    };
  }

  function removeDuplicatePriceNodes(container, priceEl) {
    if (!container || !priceEl) return;

    container.querySelectorAll('.js-ms-subtotal-part').forEach(function (node) {
      if (node !== priceEl) node.classList.add('ig-price-duplicate');
    });

    container.querySelectorAll('[class*="intelli"]').forEach(function (node) {
      if (node === priceEl || priceEl.contains(node) || node.contains(priceEl)) return;
      node.classList.add('ig-price-duplicate');
    });

    Array.from(container.querySelectorAll('span, div')).forEach(function (node) {
      if (node === priceEl || node === container) return;
      if (node.classList.contains('js-ms-compare-price') || node.classList.contains('price-compare')) return;
      if (node.classList.contains('sr-only')) return;
      if (priceEl.contains(node) || node.contains(priceEl)) return;
      if (node.querySelector('.js-ms-subtotal-part')) return;

      var text = (node.textContent || '').trim();
      if (text && /[$£€¥]|\d+[.,]\d{2}/.test(text)) {
        node.classList.add('ig-price-duplicate');
      }
    });
  }

  function applyPriceToElement(el, variantId, basePriceCents, baseCompareCents) {
    if (!el || !variantId) return;

    var priceCents = igPriceCents(variantId, basePriceCents);
    var compareCents = igCompareCents(variantId, baseCompareCents || 0);
    var onSale = compareCents > priceCents;
    var container = el.closest('.product__mso--price');

    el.textContent = formatMoneyFromCents(priceCents);
    el.setAttribute('data-price', String(priceCents));
    el.setAttribute('data-variant-id', String(variantId));
    el.classList.toggle('price-on-sale', onSale);
    el.classList.remove('ig-price-duplicate');

    var compareEl =
      (container && container.querySelector('.js-ms-compare-price, .price-compare')) ||
      (el.parentElement &&
        el.parentElement.querySelector('.js-ms-compare-price, .price-compare'));

    if (compareEl) {
      if (onSale) {
        compareEl.textContent = formatMoneyFromCents(compareCents);
        compareEl.setAttribute('data-price', String(compareCents));
        compareEl.setAttribute('data-variant-id', String(variantId));
        compareEl.classList.remove('hide', 'ig-price-duplicate');
        compareEl.setAttribute('aria-hidden', 'false');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('hide');
        compareEl.setAttribute('aria-hidden', 'true');
      }
    }

    removeDuplicatePriceNodes(container, el);
  }

  function updateModuleHeaderPrice(module, selection, variants) {
    var variant = findModuleVariant(selection, variants);
    if (!variant) return false;

    var priceEl = module.querySelector('.product__mso--price .js-ms-subtotal-part');
    if (!priceEl) return false;

    applyPriceToElement(
      priceEl,
      variant.id,
      Number(variant.price) || 0,
      Number(variant.compare_at_price) || 0
    );

    return true;
  }

  function refreshModulePrice(module, mainColorValue) {
    var form = document.querySelector('.js-product-ms-form-main');
    if (!form) return;

    if (!shouldShowModulePrice(module)) {
      setModulePriceVisible(module, false);
      return;
    }

    var selection = getModuleSelection(module, mainColorValue);
    if (!selection) return;

    if (updateModuleHeaderPrice(module, selection, getVariants(form))) {
      setModulePriceVisible(module, true);
    }
  }

  function refreshAllModulePrices(mainColorValue) {
    document.querySelectorAll('.js-module-selector').forEach(function (module) {
      refreshModulePrice(module, mainColorValue);
    });
  }

  function getProductVariantsData() {
    var el = document.querySelector('#productVariantsData');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getCheapestVariantForColor(colorValue) {
    var data = getProductVariantsData();
    if (!data || !colorValue) return null;

    var pattern = new RegExp(
      '/\\s*' + String(colorValue).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*$',
      'i'
    );
    var cheapest = null;

    Object.keys(data).forEach(function (key) {
      if (!key || !pattern.test(key)) return;
      var entry = data[key];
      if (!entry || !entry.available) return;
      var price = Number(entry.price || 0);
      if (!Number.isFinite(price) || price <= 0) return;
      if (!cheapest || price < Number(cheapest.price || 0)) cheapest = entry;
    });

    return cheapest;
  }

  function updateTopPricesFromMainColor(mainColorValue) {
    var variant = getCheapestVariantForColor(mainColorValue);
    if (!variant) return;

    var priceCents = igPriceCents(variant.id, Number(variant.price) || 0);
    var compareCents = igCompareCents(variant.id, Number(variant.compare_at_price) || 0);
    var onSale = compareCents > priceCents;

    document
      .querySelectorAll('.product__price .js-ms-price, .product__price .js-price')
      .forEach(function (el) {
        el.textContent = formatMoneyFromCents(priceCents);
        el.setAttribute('data-price', String(priceCents));
        el.setAttribute('data-variant-id', String(variant.id));
        el.classList.toggle('price-on-sale', onSale);
      });

    document
      .querySelectorAll('.product__price .js-ms-compare-price, .product__price .js-compare-price')
      .forEach(function (el) {
        if (onSale) {
          el.textContent = formatMoneyFromCents(compareCents);
          el.setAttribute('data-price', String(compareCents));
          el.setAttribute('data-variant-id', String(variant.id));
          el.classList.remove('hide');
          el.setAttribute('aria-hidden', 'false');
        } else {
          el.textContent = '';
          el.classList.add('hide');
          el.setAttribute('aria-hidden', 'true');
        }
      });
  }

  function getModuleQuantity(module) {
    var qtyInput =
      module.querySelector('.js-ps-mso-qty-update input[type="number"]') ||
      module.querySelector('.js-ps-mso-qty input[type="number"]') ||
      module.querySelector('.js-ms-cta-qty input[type="number"]');
    return qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
  }

  // A module is part of the order once its footer is shown (confirmed) or,
  // in Replo layouts, when its option is marked active/update.
  function isModuleInOrder(module) {
    if (isModuleConfirmed(module)) return true;
    var option = module.closest('.product__ms--option');
    return !!(
      option &&
      (option.classList.contains('is-active') || option.classList.contains('is-update'))
    );
  }

  // Reads the price that is ALREADY displayed inside the module
  // (.product__mso--price). This is the value the customer sees, so the ATC
  // total always matches the sum of the module prices.
  function readModuleDisplayedPrice(module) {
    var container = module.querySelector('.product__mso--price');
    if (!container || container.classList.contains(HIDDEN_CLASS)) return null;

    var priceEl = container.querySelector('.js-ms-subtotal-part');
    if (!priceEl) return null;

    var priceCents =
      Number(priceEl.getAttribute('data-price')) ||
      parseIgMoneyToCents(priceEl.textContent);
    if (!priceCents) return null;

    var compareCents = 0;
    var compareEl = container.querySelector('.js-ms-compare-price, .price-compare');
    if (compareEl && !compareEl.classList.contains('hide')) {
      compareCents =
        Number(compareEl.getAttribute('data-price')) ||
        parseIgMoneyToCents(compareEl.textContent) ||
        0;
    }

    return { priceCents: priceCents, compareCents: compareCents };
  }

  function getCartItemsFromConfirmedModules() {
    var items = [];

    document.querySelectorAll('.js-module-selector').forEach(function (module) {
      if (!isModuleInOrder(module)) return;

      var displayed = readModuleDisplayedPrice(module);
      if (!displayed) return;

      items.push({
        // Prices are read straight from the displayed (IG-applied) values,
        // so they must be passed through unchanged, not re-resolved by IG.
        priceCents: displayed.priceCents,
        compareCents: displayed.compareCents,
        quantity: getModuleQuantity(module),
      });
    });

    return items;
  }

  // The Add to Cart label is built by the theme and already contains
  // .atc-price-compare / .atc-price-sale spans with the combined total.
  // When an IntelliGems test is running we re-apply the IG-adjusted combined
  // totals onto those existing spans. We never create, hide or blank them so
  // the theme stays in control of the button's structure and visibility.
  function refreshAddToCartButtonsFromModules() {
    var items = getCartItemsFromConfirmedModules();
    if (!items.length) return;

    var totalPrice = 0;
    var totalCompare = 0;
    var hasCompare = false;

    items.forEach(function (item) {
      var qty = Number(item.quantity) || 0;
      totalPrice += qty * item.priceCents;
      if (item.compareCents > item.priceCents) {
        hasCompare = true;
        totalCompare += qty * item.compareCents;
      } else {
        totalCompare += qty * item.priceCents;
      }
    });

    document
      .querySelectorAll(
        '.add-to-cart-button.js-ms-add-to-cart, .add-to-cart-button.js-ps-ms-add-to-cart'
      )
      .forEach(function (button) {
        var saleEl = button.querySelector('.atc-price-sale');
        var compareEl = button.querySelector('.atc-price-compare');
        if (!saleEl) return;

        saleEl.textContent = formatMoneyFromCents(totalPrice);
        saleEl.setAttribute('data-price', String(totalPrice));
        saleEl.setAttribute('data-ig-aggregate', 'true');
        // Never let the price stay hidden: clear any stale hide state.
        saleEl.classList.remove('hide');
        saleEl.setAttribute('aria-hidden', 'false');

        if (compareEl && hasCompare) {
          compareEl.textContent = formatMoneyFromCents(totalCompare);
          compareEl.setAttribute('data-price', String(totalCompare));
          compareEl.setAttribute('data-ig-aggregate', 'true');
          compareEl.classList.remove('hide');
          compareEl.setAttribute('aria-hidden', 'false');
        }
      });
  }

  function refreshAddToCartButtonsFromCart(cartState, formatMoneyFn) {
    if (!cartState || !Array.isArray(cartState.items) || !cartState.items.length) return;

    var totalPrice = 0;
    var totalCompare = 0;
    var hasCompare = false;
    var leadVariantId = null;

    cartState.items.forEach(function (item) {
      var variantId = item.id;
      var qty = Number(item.quantity) || 0;
      var basePrice = Number(item.properties && item.properties._Price) || 0;
      var baseCompare = Number(item.properties && item.properties._ComparePrice) || 0;
      var priceCents = igPriceCents(variantId, basePrice);
      var compareCents = igCompareCents(variantId, baseCompare);

      if (!leadVariantId) leadVariantId = variantId;
      totalPrice += qty * priceCents;
      if (compareCents > priceCents) {
        hasCompare = true;
        totalCompare += qty * compareCents;
      }
    });

    document
      .querySelectorAll('.add-to-cart-button.js-ms-add-to-cart, .add-to-cart-button.js-ps-ms-add-to-cart')
      .forEach(function (button) {
        var compareEl = button.querySelector('.atc-price-compare');
        var saleEl = button.querySelector('.atc-price-sale');
        if (!saleEl) return;

        saleEl.textContent = formatMoneyFn(totalPrice);
        saleEl.setAttribute('data-price', String(totalPrice));
        saleEl.setAttribute('data-ig-aggregate', 'true');
        if (leadVariantId) saleEl.setAttribute('data-variant-id', String(leadVariantId));
        saleEl.classList.remove('hide');
        saleEl.setAttribute('aria-hidden', 'false');

        if (compareEl) {
          if (hasCompare) {
            compareEl.textContent = formatMoneyFn(totalCompare);
            compareEl.setAttribute('data-price', String(totalCompare));
            compareEl.setAttribute('data-ig-aggregate', 'true');
            compareEl.classList.remove('hide');
            compareEl.setAttribute('aria-hidden', 'false');
          } else {
            // Clear the value but never add `hide` (the theme owns visibility).
            compareEl.textContent = '';
            compareEl.setAttribute('aria-hidden', 'true');
          }
        }
      });
  }

  window.fmRefreshIgAtcPrices = function (cartState, formatMoneyFn) {
    var moneyFn = formatMoneyFn || formatMoneyFromCents;

    if (cartState && Array.isArray(cartState.items) && cartState.items.length) {
      refreshAddToCartButtonsFromCart(cartState, moneyFn);
      return;
    }

    refreshAddToCartButtonsFromModules();
  };

  function refreshAll() {
    var mainColorInput = document.querySelector('.js-ms-main-color-option:checked');
    var mainColorValue = mainColorInput ? mainColorInput.value : null;

    refreshAllModulePrices(mainColorValue);

    if (mainColorValue) {
      updateTopPricesFromMainColor(mainColorValue);
    }

    refreshAddToCartButtonsFromModules();
  }

  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      requestAnimationFrame(refreshAll);
    }, 0);
  }

  function onModuleAddOpen(module) {
    clearSizeSelected(module);
    setModulePriceVisible(module, false);
  }

  function onModuleSizeChosen(module) {
    markSizeSelected(module);
    scheduleRefresh();
  }

  function onModuleColorChange(module) {
    if (isOptionsPanelOpen(module)) {
      clearSizeSelected(module);
      setModulePriceVisible(module, false);
    }
  }

  function onOptionChange(event) {
    var target = event.target;
    if (!target || !target.matches) return;

    if (target.matches('.js-ps-mso-size')) {
      var module = target.closest('.js-module-selector');
      if (module) onModuleSizeChosen(module);
      return;
    }

    if (target.matches('.js-ps-mso-color')) {
      var colorModule = target.closest('.js-module-selector');
      if (colorModule) onModuleColorChange(colorModule);
      scheduleRefresh();
      return;
    }

    if (
      target.matches('.js-ps-mso-qty') ||
      target.closest('.js-ps-mso-qty-update') ||
      target.closest('.js-ps-mso-qty')
    ) {
      var qtyModule = target.closest('.js-module-selector');
      if (qtyModule && isOptionsPanelOpen(qtyModule) && !hasUserSelectedSize(qtyModule)) {
        setModulePriceVisible(qtyModule, false);
      }
      scheduleRefresh();
      return;
    }

    if (target.matches('.js-ms-main-color-option')) {
      document.querySelectorAll('.js-module-selector').forEach(function (module) {
        if (isOptionsPanelOpen(module) && !hasUserSelectedSize(module)) {
          setModulePriceVisible(module, false);
        }
      });
      scheduleRefresh();
    }
  }

  function onOptionClick(event) {
    var addBtn = event.target.closest('.js-ms-options-show[data-module-behaviour="show"]');
    if (addBtn) {
      var addModule = addBtn.closest('.js-module-selector');
      if (addModule) onModuleAddOpen(addModule);
      return;
    }

    var sizeOption = event.target.closest('.product__mso--option-size');
    if (sizeOption) {
      var sizeModule = sizeOption.closest('.js-module-selector');
      if (sizeModule) {
        window.requestAnimationFrame(function () {
          onModuleSizeChosen(sizeModule);
        });
      }
      return;
    }

    var colorSwatch = event.target.closest('.js-ps-msl-color, .product__cs--value');
    if (colorSwatch) {
      scheduleRefresh();
    }
  }

  function onModuleConfirm(event) {
    var confirmBtn = event.target.closest('.js-ms-confirm-cart-items');
    if (!confirmBtn) return;
    var module = confirmBtn.closest('.js-module-selector');
    if (!module) return;
    markSizeSelected(module);
    scheduleRefresh();
  }

  function onModuleRemoved(event) {
    var removeBtn = event.target.closest('[data-module-item-remove], .js-ms-options-hide');
    if (!removeBtn) return;
    scheduleRefresh();
  }

  document.addEventListener('change', onOptionChange, false);
  document.addEventListener('click', onOptionClick, false);
  document.addEventListener('click', onModuleConfirm, false);
  document.addEventListener('click', onModuleRemoved, false);

  if (window.EventBus && typeof window.EventBus.on === 'function') {
    window.EventBus.on('product:update', scheduleRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh);
  } else {
    scheduleRefresh();
  }

  var igPollStarted = Date.now();
  var igPoll = setInterval(function () {
    if (window.igData && window.igData.price) {
      clearInterval(igPoll);
      scheduleRefresh();
      return;
    }
    if (Date.now() - igPollStarted > IG_POLL_MAX_MS) clearInterval(igPoll);
  }, IG_POLL_MS);
})();
